import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/styles'; // eslint-disable-line import/no-extraneous-dependencies
import { LocationProvider } from '@reach/router';
import React from 'react';
import { hot } from 'react-hot-loader';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import { defaultQueryFn, queryCacheStrategies, reactQueryRetry } from 'api';
import { registerFetchIntercept } from 'hooks/useInventoryUpdates';

import theme from '../common/theme';
import AppRouter from '../navigation';

registerFetchIntercept();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
      ...(queryCacheStrategies.basic as any),
      retry: reactQueryRetry,
    },
  },
});

const App: React.FC = () => {
  return (
    <LocationProvider>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <CssBaseline />
          <AppRouter />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </ThemeProvider>
    </LocationProvider>
  );
};

export default hot(module)(App);
